import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { StorageHandler } from 'C4';
import { storageKeys } from 'settings';

const HeaderHandler = () => {
  const [metaTags, setMetaTags] = useState({
    title: '',
    description: '',
    image: '',
    icon: '',
  });

  useEffect(() => {
    const loadFromLocalStorage = async () => {
      const appInfo = await StorageHandler.load(storageKeys.appInfo);
      if (appInfo) {
        setMetaTags((prevTags) => ({
          ...prevTags,
          title: appInfo.appName,
          description: appInfo.landingQuote,
          image: appInfo.backgroundImage,
          icon: appInfo.appIcon,
        }));
      }
    };

    loadFromLocalStorage();
  }, []);

  return (
    <div>
      <Helmet>
        <title>{metaTags.title}</title>
        <meta name="description" content={metaTags.description} />
        <meta property="og:title" content={metaTags.title} />
        <meta property="og:description" content={metaTags.description} />
        <meta property="og:image" content={metaTags.image} />
        <link rel="icon" type="image/png" href={metaTags.icon} />
      </Helmet>
    </div>
  );
};

export default HeaderHandler;